module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-news-6fc20a93ca8ac2ee776ab18a94cf62b6.svg";